import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useReactToPrint } from 'react-to-print';
import { Alert, IconButton, Stack, Typography } from '@mui/material';
import { CloseTwoTone, PrintTwoTone } from '@mui/icons-material';
import { IFILogo } from './IFILogo';

const PrintDocStyle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-inline: 1em;
  word-break: break-word;
  @media print {
    margin-top: 1.5em;
    @page {
      size: landscape;
    }
  }
`;
const ComponentToPrint = React.forwardRef((props, ref) => (
  <PrintDocStyle ref={ref}>
    <IFILogo size={{ width: '100%' }} />
    <Typography variant="h2">Welcomes...</Typography>
    <Typography variant="h1">{props.StudentName}</Typography>
  </PrintDocStyle>
));

const WelcomeStudent = (props) => {
  const { state } = props.location;
  const componentRef = React.useRef(null);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => goBack(),
  });

  useEffect(handlePrint);

  const goBack = () => props.history.goBack();

  if (!state) {
    return (
      <Alert severity="warning" onClose={goBack}>
        No Student found to show welcome sign
      </Alert>
    );
  } else if (state.isPendingApproval) {
    return (
      <Alert severity="warning" onClose={goBack}>
        Volunteer match request needs approval.
      </Alert>
    );
  }

  return (
    <Stack spacing={2}>
      <Stack spacing={0.5} direction="row" justifyContent="flex-end">
        <IconButton aria-label="print" onClick={handlePrint} color="primary">
          <PrintTwoTone />
        </IconButton>
        <IconButton aria-label="close" onClick={goBack}>
          <CloseTwoTone />
        </IconButton>
      </Stack>
      <ComponentToPrint ref={componentRef} StudentName={state.StudentName} />
    </Stack>
  );
};

export { WelcomeStudent };
